export { default as ChatScreen } from './pages/chat-screen/index';
